import { put, takeLatest } from "redux-saga/effects";
import {
  GET_PROFILE,
  GET_PROFILE_INIT,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILED,
  UPDATE_INFO,
  UPDATE_INFO_INIT,
  UPDATE_INFO_SUCCESS,
  UPDATE_INFO_FAILED,
  GET_ALL_INVESTOR,
  GET_ALL_INVESTOR_INIT,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  GET_STRATEGY,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  UPDATE_COVER_IMAGE,
  UPDATE_COMPANY_LOGO,
  UPDATE_COVER_IMAGE_INIT,
  UPDATE_COVER_IMAGE_SUCCESS,
  UPDATE_COVER_IMAGE_FAILED,
  UPDATE_COMPANY_LOGO_INIT,
  UPDATE_COMPANY_LOGO_SUCCESS,
  UPDATE_COMPANY_LOGO_FAILED,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_PMRESULT_FAILED,
  SEARCH_PMRESULT,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  SEARCH_REPORTRESULT,
  SEARCH_RPRESULT,
  GET_FUND_DETAIL,
  GET_FUND_DETAIL_INIT,
  GET_FUND_DETAIL_SUCCESS,
  GET_FUND_DETAIL_FAILED,
  UPLOAD_FILE_DECK_INIT,
  UPLOAD_FILE_DECK_SUCCESS,
  UPLOAD_FILE_DECK_FAILED,
  UPLOAD_FILE_DECK,
  UPLOAD_TEAR_SHEET_INIT,
  UPLOAD_TEAR_SHEET_SUCCESS,
  UPLOAD_TEAR_SHEET_FAILED,
  UPLOAD_TEAR_SHEET,
  GET_CLOUD_DECKS_INIT,
  GET_CLOUD_DECKS_SUCCESS,
  GET_CLOUD_DECKS_FAILED,
  GET_MEDIA_INIT,
  GET_MEDIA_SUCCESS,
  GET_MEDIA_FAILED,
  GET_CLOUD_DECKS,
  GET_MEDIA,
  GET_INVESTED_ALLOCATORS_INIT,
  GET_INVESTED_ALLOCATORS_SUCCESS,
  GET_INVESTED_ALLOCATORS_FAILED,
  GET_INVESTED_ALLOCATORS,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED,
  GET_ALLOCATOR_USERS,
  CREATE_CHAT_ROOM_INIT,
  CREATE_CHAT_ROOM_SUCCESS,
  CREATE_CHAT_ROOM_FAILED,
  CREATE_CHAT_ROOM
} from "./constants";
import { getUtil, postUtil, putUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";

const getDocumentParams = [
  { keyword: "RecordId", value: "recordId" },
  { keyword: "RecordType", value: "recordType" },
  { keyword: "DocType", value: "docType" },
];

export function* hedgeFundProfile() {
  yield put({ type: GET_PROFILE_INIT });
  try {
    const res = yield getUtil(`${API.HedgeFundProfile}`);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_PROFILE_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_PROFILE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* hadgeFundUpdateInfo({ payload, onSuccess }) {
  yield put({ type: UPDATE_INFO_INIT });
  try {
    const res = yield putUtil(API.UpdateTenant, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_INFO_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_INFO_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

function* getallInvestors() {
  yield put({ type: GET_ALL_INVESTOR_INIT });
  try {
    const res = yield getUtil(API.InvestorType);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_INVESTOR_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_INVESTOR_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALL_INVESTOR_FAILED });
    throw new Error(error);
  }
}

function* getStrategy() {
  yield put({ type: GET_STRATEGY_INIT });
  try {
    const res = yield getUtil(API.GetStrategies);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_STRATEGY_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_STRATEGY_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_STRATEGY_FAILED });
    throw new Error(error);
  }
}


function* updateTenantCoverImageSaga({ payload, onSuccess, onCloseModal }) {
  yield put({ type: UPDATE_COVER_IMAGE_INIT });
  try {
    const res = yield putUtil(API.UpdateTenantCoverImage, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_COVER_IMAGE_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPDATE_COVER_IMAGE_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_COVER_IMAGE_FAILED });
    throw new Error(error);
  }
}

function* updateTenantCompanyLogoSaga({ payload, onSuccess, onCloseModal }) {
  yield put({ type: UPDATE_COMPANY_LOGO_INIT });
  try {
    const res = yield putUtil(API.UpdateTenantCompantLogo, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_COMPANY_LOGO_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPDATE_COMPANY_LOGO_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_COMPANY_LOGO_FAILED });
    throw new Error(error);
  }
}

export function* getPerformanceMetricsSearchResult({ payload }) {
  const { id, year } = payload || {};
  yield put({ type: SEARCH_PMRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetPerformanceMetricsSearchResult}?fundId=${id}&year=${year}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_PMRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_PMRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* GetRiskReportSearchResult({ payload }) {
  const { id } = payload || {};
  yield put({ type: SEARCH_RPRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetRiskReportSearchResult}?fundId=${id}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_RPRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_RPRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* RiskReportSearchResultByMonth({ payload }) {
  const { id, month, riskReportType } = payload || {};
  yield put({ type: SEARCH_REPORTRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.RiskReportSearchResultByMonth}?fundId=${id}&month=${month}&riskReportType=${riskReportType}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_REPORTRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_REPORTRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getFundDetail({ id }) {
  yield put({ type: GET_FUND_DETAIL_INIT });
  try {
    const res = yield getUtil(`${API.FundProfileDetail}?id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_DETAIL_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* uploadFileDeckSaga({ payload ,onSuccessAlert , onCloseModal}) {
  yield put({ type: UPLOAD_FILE_DECK_INIT });
  try {
    
    const res = yield postUtil(`${API.UploadFileDeck}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: UPLOAD_FILE_DECK_SUCCESS,
        payload: data.result,
      });
      onCloseModal();
      onSuccessAlert();
    } else {
      yield put({ type: UPLOAD_FILE_DECK_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* uploadTear({ payload, onSuccess,onCloseModal }) {
  yield put({ type: UPLOAD_TEAR_SHEET_INIT });
  try {
    const res = yield postUtil(`${API.TearSheetUpload}`, payload);

    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPLOAD_TEAR_SHEET_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPLOAD_TEAR_SHEET_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
function* getCloudDecksSaga({ payload }) {
  yield put({ type: GET_CLOUD_DECKS_INIT });
  try {
    let url = API.getRecordFiles + GenerateUrl(payload, getDocumentParams);

    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_CLOUD_DECKS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_CLOUD_DECKS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_CLOUD_DECKS_FAILED });
    throw new Error(error);
  }
}

function* getMediaSaga({ payload }) {
  yield put({ type: GET_MEDIA_INIT });
  try {
    const res = yield getUtil(`${API.getRecordFiles}?RecordType=${payload?.recordType}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_MEDIA_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_MEDIA_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_MEDIA_FAILED });
    throw new Error(error);
  }
}

export function* getInvestedCompaniesList() {
  yield put({ type: GET_INVESTED_ALLOCATORS_INIT });
  try {
    const res = yield getUtil(API.GetinvestedAllocator);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_INVESTED_ALLOCATORS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_INVESTED_ALLOCATORS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getAllocatorUsersSaga({ payload }) {
  yield put({ type: GET_ALLOCATOR_USERS_INIT });
  try {
    const res = yield getUtil(`${API.GetAllocatorUsers}?id=${payload}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_ALLOCATOR_USERS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_ALLOCATOR_USERS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* createChatRoomSaga({ payload, callback }) {
  yield put({ type: CREATE_CHAT_ROOM_INIT });
  try {
    const res = yield postUtil(API.CreateChatRoom, payload);
    if (res?.status === 200) {
      const { data } = res;
      callback(res.data.result.id);

      yield put({
        type: CREATE_CHAT_ROOM_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: CREATE_CHAT_ROOM_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* profile() {
  yield takeLatest(GET_PROFILE, hedgeFundProfile);
  yield takeLatest(UPDATE_INFO, hadgeFundUpdateInfo);
  yield takeLatest(GET_ALL_INVESTOR, getallInvestors);
  yield takeLatest(GET_STRATEGY, getStrategy);
  yield takeLatest(UPDATE_COVER_IMAGE, updateTenantCoverImageSaga);
  yield takeLatest(UPDATE_COMPANY_LOGO, updateTenantCompanyLogoSaga);
  yield takeLatest(SEARCH_PMRESULT, getPerformanceMetricsSearchResult);
  yield takeLatest(SEARCH_RPRESULT, GetRiskReportSearchResult);
  yield takeLatest(SEARCH_REPORTRESULT, RiskReportSearchResultByMonth);
  yield takeLatest(GET_FUND_DETAIL, getFundDetail);
  yield takeLatest(UPLOAD_FILE_DECK, uploadFileDeckSaga);
  yield takeLatest(UPLOAD_TEAR_SHEET, uploadTear);
  yield takeLatest(GET_CLOUD_DECKS, getCloudDecksSaga);
  yield takeLatest(GET_MEDIA, getMediaSaga);
  yield takeLatest(GET_INVESTED_ALLOCATORS, getInvestedCompaniesList);
  yield takeLatest(GET_ALLOCATOR_USERS, getAllocatorUsersSaga);
  yield takeLatest(CREATE_CHAT_ROOM, createChatRoomSaga);
}
